export default __webpack_public_path__ + "static/sustainable-tourism.en-8919b328420d628f371f78bed9d16f20.png";